import React, { createContext, ReactNode, useContext } from 'react';
import { FormProvider as RHFProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { RegisterFormSchema } from 'services/AuthService/schemas';

type RegisterFormInput = z.infer<typeof RegisterFormSchema>;

type ContextType = {
  control: any;
  handleSubmit: ReturnType<typeof useForm<RegisterFormInput>>['handleSubmit'];
  errors: any;
  setValue: ReturnType<typeof useForm<RegisterFormInput>>['setValue'];
  getValues: ReturnType<typeof useForm<RegisterFormInput>>['getValues']; // Adicionado getValues
  formState: {
    errors: any;
  };
};

type AuthenticationProviderProps = {
  children: ReactNode;
};

const AuthenticationContext = createContext<ContextType | undefined>(undefined);

export const AuthenticationProvider = ({
  children,
}: AuthenticationProviderProps) => {
  const methods = useForm<RegisterFormInput>({
    resolver: zodResolver(RegisterFormSchema),
    defaultValues: {
      email: '',
      password: '',
      name: '',
      cpf: '',
      cnpj: '',
      postalCode: '',
      city: '',
      state: '',
      street: '',
      addrNumber: '',
      neighborhood: '',
      product: '',
      plans: [''],
    },
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
  } = methods;

  return (
    <AuthenticationContext.Provider
      value={{
        control,
        handleSubmit,
        errors,
        setValue,
        getValues,
        formState: { errors },
      }}
    >
      <RHFProvider {...methods}>{children}</RHFProvider>
    </AuthenticationContext.Provider>
  );
};

export const useAuthenticationContext = () => {
  const context = useContext(AuthenticationContext);
  if (context === undefined) {
    throw new Error(
      'useAuthenticationContext precisa ser usado dentro do AuthenticationProvider',
    );
  }
  return context;
};
